/**
 * @module views\sys\upload
 */
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Index extends Vue {}
